module.exports = __webpack_public_path__ + "img/1-icono-nuevo-selected.0cb037a1.svg";